(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('component', {
        templateUrl: 'views/components/views/component/component.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'componentService', 'stockAssignService', 'documentsService', 'typeaheadService', function ($stateParams, stateService, utilityService, modalService, translateService, componentService, stockAssignService, documentsService, typeaheadService) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let prodId = $stateParams.prod_id;
            let compKeyno = $stateParams.comp_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                compKeyno: compKeyno,
                productSearchButtons: [
                    { id: 'new', icon: 'fa fa-solid fa-plus', color: 'primary', type: 'primary', onClick: () => stateService.go('productcreate', { argtype: 'prod_keyno', argvalue: vm.model.edit.prod_keyno }) }
                ],
                compIsProdButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.comp_is_prod_id }) }
                ],
                replaceableComponentButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('componentreplaceables', { comp_keyno: vm.model.edit.comp_keyno }) }
                ],
                edit: {},
                selectListProductUnits: [],
                itemsListDocuments: [],
                lockedSave: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION SERVICE FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION SERVICE FUNCTION

            // #region LOAD PROCEDURE CALLS
            
            async function loadEdit() {
                vm.model.edit = (await componentService.getEdit({
                    prod_id: prodId,
                    comp_keyno: compKeyno
                }))[0];

                return Promise.all([
                    loadProductUnits(),
                    loadDocuments()
                ]).then(() => {
                    if (vm.model.edit.prod_id_new > '') retrieveProductChanged();

                    Promise.resolve();
                });
            }

            async function loadProductUnits() {
                if (utilityService.validateParmsValue(vm.model.edit.comp_is_prod_id) !== true) return;

                return vm.model.selectListProductUnits = await stockAssignService.listProductUnits({ prod_id: vm.model.edit.comp_is_prod_id });
            }

            async function loadDocuments() {
                if (utilityService.validateParmsValue(vm.model.edit.prod_id) !== true) return;

                return vm.model.itemsListDocuments = await documentsService.listDocuments({
                    argtype: 'prod_id',
                    argvalue: vm.model.edit.prod_id,
                    searchtext: '',
                    doctype: 'd',
                    onlyFilenames: '0',
                    glyphicon_select: '1'
                });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region PRODUCT CHANGED FUNCTION

            function retrieveProductChanged() {
                if (utilityService.validateParmsValue(vm.model.edit.comp_is_prod_id) !== true) return;

                return componentService.getProductChanged({
                    comp_is_prod_id: vm.model.edit.comp_is_prod_id,
                    prod_id: $stateParams.prod_id
                }).then((response) => {
                    vm.model.edit.comp_is_prod_id = response[0].comp_is_prod_id;
                    vm.model.edit.comp_prod_name = response[0].comp_prod_name;
                    vm.model.edit.comp_waste_pst = response[0].waste_pst;
                    vm.model.edit.url_picture = response[0].url_picture;

                    if (response[0].comp_is_prod_id > '') {
                        return Promise.all([
                            loadProductUnits()
                        ]).then(() => {
                            vm.model.edit.stock_unit_no = response[0].stock_unit_no;
                            vm.model.edit.input_unit_no = response[0].stock_unit_no;

                            Promise.resolve();
                        });
                    }
                });
            }

            // #endregion PRODUCT CHANGED FUNCTION

            // #region RECALCULATION FUNCTION

            function retrieveCalculation(id) {
                switch (id) {
                    case 'special_length':
                    case 'special_width':
                    case 'special_quantity':
                    case 'special_quantity_formula':
                    case 'input_unit_no':
                    case 'input_quantity':
                    case 'input_calc_quantity':
                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                        let mergeObj = {};
                        mergeObj = vm.model.edit;
                        mergeObj.changedcol = id;

                        return componentService.calcObj(mergeObj).then(function (response) {
                            if (response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                        }
                                    }]
                                });
                            } else {
                                vm.model.edit.quantity = response[0].quantity;

                                //console.log('changedcol: ' + mergeObj.changedcol);

                                if (mergeObj.changedcol !== 'input_quantity') {
                                    vm.model.edit.input_quantity = response[0].input_quantity;
                                }
                            }
                        });
                        break;
                    default:
                        break;
                };
            }

            // #endregion RECALCULATION FUNCTION

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'product_search':
                        vm.model.edit[id] = value;

                        return typeaheadService.searchProduct({
                            prod_name: vm.model.edit[id] || '',
                            webpage_name: stateService.getCurrentName(),
                            parm1: prodId,
                            parm2: compKeyno,
                            supplier_no: '0'
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'product_search':
                        if (item) {
                            vm.model.edit.comp_is_prod_id = item?.item_id ?? '';
                            vm.model.edit.product_search = item?.item_name ?? '';

                            retrieveProductChanged();
                        } else {
                            vm.onTypeaheadClear('product_search');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'product_search':
                        vm.model.edit.product_search = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.edit.comp_is_prod_id = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('product_search');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'product_search':
                        vm.model.edit.comp_is_prod_id = '';
                        vm.model.edit.stock_unit_no = '';
                        vm.model.edit.input_unit_no = '';
                        vm.model.edit.product_search = '';
                        vm.model.edit.comp_prod_name = '';
                        vm.model.selectListProductUnits = [];
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                componentService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            }

            // #endregion BUTTON PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    componentService.deleteItem(vm.model.edit).then((response) => {
                        //if (response[0] && response[0].errorcode !== '0') {
                        //	modalService.show({
                        //		type: 'warning',
                        //		title: translations.error,
                        //		message: response[0].errormessage,
                        //		buttons: [{
                        //			label: translations.ok,
                        //			cssClass: 'btn-warning',
                        //			action: function (dialogItself) {
                        //				dialogItself.close();
                        //				vm.model.lockedDelete = false;
                        //			}
                        //		}]
                        //	});
                        //} else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        //}
                    }, () => {
                        vm.model.lockedDelete = false;
                    });
                }, () => {
                    vm.model.lockedDelete = false;
                });
            }

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'input_unit_no':
                        if (utilityService.validateWatchValue(value, vm.model.edit.input_unit_no) !== true) return;

                        vm.model.edit.input_unit_no = value;

                        if (utilityService.validateParmsValue(vm.model.edit.input_unit_no, true) !== true) return;

                        retrieveCalculation(id);
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON BLUR MULTI FUNCTION

            vm.onBlur = function (id) {
                switch (id) {
                    case 'quantity':
                    case 'special_length':
                    case 'special_width':
                    case 'special_quantity':
                    case 'input_quantity':
                    case 'input_calc_quantity':
                    case 'special_quantity_formula':
                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

                        retrieveCalculation(id);
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTION

            // #region ANGULAR LIFECYCLE FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
            }

            // #endregion ANGULAR LIFECYCLE FUNCTION

        }]
    });
})();
